import { action, Action } from 'typesafe-actions'

import { AuthenticationTypes } from './types'

export const authenticationRequest = (): Action =>
  action(AuthenticationTypes.AUTHENTICATION_REQUEST)

export const setCpfAuthentication = (payload: string | undefined): Action =>
  action(AuthenticationTypes.SET_CPF_AUTHENTICATION, payload)

export const setUserNameAuthentication = (payload: string | undefined): Action =>
  action(AuthenticationTypes.SET_USERNAME_AUTHENTICATION, payload)
